module.exports = __webpack_public_path__ + "img/other-order.22ba9587.svg";